export default "{\n    \"callback\": \"Rappel\"\n}\n"